var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25C8.76562 21.25 5.8125 19.5625 4.19531 16.75C2.57812 13.9727 2.57812 10.5625 4.19531 7.75C5.8125 4.97266 8.76562 3.25 12 3.25C15.1992 3.25 18.1523 4.97266 19.7695 7.75C21.3867 10.5625 21.3867 13.9727 19.7695 16.75C18.1523 19.5625 15.1992 21.25 12 21.25ZM15.9727 10.5977H15.9375C16.2891 10.2812 16.2891 9.75391 15.9375 9.40234C15.6211 9.08594 15.0938 9.08594 14.7773 9.40234L10.875 13.3398L9.22266 11.6875C8.87109 11.3359 8.34375 11.3359 8.02734 11.6875C7.67578 12.0039 7.67578 12.5312 8.02734 12.8477L10.2773 15.0977C10.5938 15.4492 11.1211 15.4492 11.4727 15.0977L15.9727 10.5977Z",
    fill: "#005FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.789b87edf0d169887f20b5242cc1d179.svg";
export { ForwardRef as ReactComponent };